import { render } from "./index.vue?vue&type=template&id=5f2c575d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f2c575d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f2c575d', __exports__)) {
    api.reload('5f2c575d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5f2c575d", () => {
    api.rerender('5f2c575d', render)
  })

}


export default __exports__